import { useRef } from "react";
import { teamData, clients } from "../content/content";
import useGsapAnimations from "../../hooks/useGsapAnimations";

const CompanyAbout = () => {
  const teamCardRefs = useRef([]);
  const clientCardRefs = useRef([]);

  useGsapAnimations({
    cards: teamCardRefs,
    images: clientCardRefs,
  });

  return (
    <div className="bg-gray-50">
      {/* Our Team Section */}
      {/* <div className="p-10"> */}
        {/* <h2 className="text-3xl font-bold text-center mb-2">Our Team</h2>
        <p className="text-center text-gray-600 mb-10">We are awesome people</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {teamData.map((member, index) => (
            <div
              key={index}
              ref={(el) => (teamCardRefs.current[index] = el)}
              className="bg-white shadow-md p-2 mb-2 rounded-lg text-center"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-64 object-cover mb-4 shadow-xl"
              />
              <h3 className="text-lg font-sans font-semibold text-gray-900 mb-1">
                {member.name}
              </h3>
              <p className="text-gray-800 text-sm mb-1">{member.Designation}</p>
              <p className="text-gray-600 text-sm">{member.description}</p>
            </div>
          ))}
        </div> */}
      {/* </div> */}

      {/* Our Clients Section */}
      <div className="p-10">
        <h2 className="text-3xl font-bold text-center mb-2">Our Clients</h2>
        <span className="block border-2 border-yellow-400 w-7 h-1 mx-auto mb-4"></span>
        <p className="text-center text-gray-600 mb-10">They are awesome people</p>
        <div className="grid grid-cols-1 lg:grid-cols-4 justify-items-center">
          {clients.map((client, index) => (
            <div
              key={index}
              ref={(el) => (clientCardRefs.current[index] = el)}
              className="bg-white shadow-2xl rounded-lg text-center transition-transform duration-300 hover:shadow-lg hover:scale-105"
            >
              <img src={client.image} alt={client.name} className="w-60 h-60 object-cover rounded-md" />
              <p className="mb-5 mt-[-20px] text-gray-700 font-medium">{client.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyAbout;
